import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const NotificationGetList = createAsyncThunk(
  "NotificationGetList",
  async (data, { dispatch }) => {
    try {
      let url = `${
        API_URL.BASEURL + API_URL.NOTIFICATION.GET_LIST
      }?pagenumber=${data?.pagenumber}&pagesize=${data?.pagesize}`;
      if (data?.associationid && data?.associationtype) {
        url = `${API_URL.BASEURL + API_URL.NOTIFICATION.GET_LIST}?pagenumber=${
          data?.pagenumber
        }&pagesize=${data?.pagesize}&associationid=${
          data?.associationid
        }&associationtype=${data?.associationtype}`;
      }
      let resData = await apiCall(
        {
          method: "GET",
          url,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
export const NotificationGetListHeader = createAsyncThunk(
  "NotificationGetListHeader",
  async (data, { dispatch }) => {
    try {
      let url = `${
        API_URL.BASEURL + API_URL.NOTIFICATION.GET_LIST
      }?pagenumber=${data?.pagenumber}&pagesize=${data?.pagesize}`;
      if (data?.associationid && data?.associationtype) {
        url = `${API_URL.BASEURL + API_URL.NOTIFICATION.GET_LIST}?pagenumber=${
          data?.pagenumber
        }&pagesize=${data?.pagesize}&associationid=${
          data?.associationid
        }&associationtype=${data?.associationtype}`;
      }
      let resData = await apiCall(
        {
          method: "GET",
          url,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const UpdateNotification = createAsyncThunk(
  "UpdateNotification",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL.NOTIFICATION.UPDATE_NOTIFICATION,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const ReadAllNotification = createAsyncThunk(
  "ReadAllNotification",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "PUT",
          url: API_URL.BASEURL + API_URL.NOTIFICATION.READ_ALL,
        },
        false
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  NotificationGetListData: {
    data: null,
    error: null,
  },
  NotificationGetListHeaderData: {
    data: null,
    error: null,
  },
  UpdateNotificationData: {
    data: null,
    error: null,
  },
  ReadAllNotificationData: {
    data: null,
    error: null,
  },
};

const NotificationSlice = createSlice({
  name: "NOTIFICATION",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(NotificationGetList.fulfilled, (state, action) => {
        state.NotificationGetListData.data = action.payload;
      })
      .addCase(NotificationGetList.rejected, (state, action) => {
        state.NotificationGetListData.error = action.error.message;
      })
      .addCase(NotificationGetListHeader.fulfilled, (state, action) => {
        state.NotificationGetListHeaderData.data = action.payload;
      })
      .addCase(NotificationGetListHeader.rejected, (state, action) => {
        state.NotificationGetListHeaderData.error = action.error.message;
      })
      .addCase(UpdateNotification.fulfilled, (state, action) => {
        state.UpdateNotificationData.data = action.payload;
      })
      .addCase(UpdateNotification.rejected, (state, action) => {
        state.UpdateNotificationData.error = action.error.message;
      })
      .addCase(ReadAllNotification.fulfilled, (state, action) => {
        state.ReadAllNotificationData.data = action.payload;
      })
      .addCase(ReadAllNotification.rejected, (state, action) => {
        state.ReadAllNotificationData.error = action.error.message;
      });
  },
});

export default NotificationSlice.reducer;
